module.exports = __webpack_public_path__ + "static/media/goaltrendsv2.a120c4dd.png";